import { type SupportedLanguage, defaultLanguage, graphqlLocaleToI18n } from '@modernloop/i18n';

/**
 * Maps GraphQL `Locale` enum values from `thisOrg.supportedLocales` to i18n `SupportedLanguage`
 * codes, falling back to `[en-US]` when none resolve.
 *
 * The backend (`OrgClient.getSupportedLocales`) already normalizes the list and guarantees the org
 * default is included, so there is no default-folding to do here — this just translates enum →
 * i18n code. Shared by the recruiting and interviewer SupportedLocales providers.
 */
export function toSupportedLanguages(
  locales: ReadonlyArray<string | null | undefined> | null | undefined
): SupportedLanguage[] {
  const mapped = (locales ?? [])
    .map((locale) => graphqlLocaleToI18n(locale))
    .filter((c): c is SupportedLanguage => !!c);
  return mapped.length ? mapped : [defaultLanguage];
}
